import React, { PureComponent, PropTypes } from 'react'
import styles from './styles'
import Button from 'app/Components/Button'

export default class Footer extends PureComponent {
  render() {
    return (
      <div className={styles.footer}>
        <div className={styles.wrapper}>
          <div className={styles.center}>
            <div className={styles.title}>We’re doing big things at GHNI, and we want you to be a part of it.</div>
            <div className={styles.buttonDiv}>
              <Button href='/survey/form/'>
                BEGIN SURVEY
                <svg className={styles.svg} width='25' height='25' viewBox='0 0 24 24'>
                  <path d='M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z' />
                </svg>
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/Footer/Footer.js
 **/